import RouteDesigner from "@/router/RouteDesigner"
import Authentication from "@/middleware/Authentication"
import Authorized from "@/middleware/Authorized"
import ForceTypes from "@/middleware/ForceTypes"
import Subscribed from "@/middleware/Subscribed"
import ProfileComplete from "@/middleware/ProfileComplete"
import NotSubscribed from "@/middleware/NotSubscribed"
import NotAuthorized from "@/middleware/NotAuthorized"
import AccountOwner from "@/middleware/AccountOwner"
import NotAccountOwner from "@/middleware/NotAccountOwner"

RouteDesigner.setNotFound("Error404Page").layout("Empty")

export const ROUTES = {
  LOGIN: "login",
  OTP: 'otp-signin',
  ACCOUNT_SELECT: 'account-select',
  SUBSCRIPTION: "subscription",
  PAYMENT: "payment",
  PROFILE_COMPLETE: "profile-complete",
  CONTACT_ADMIN: "contact-admin",
  COMPLETE_PROFILE: "complete-profile",
  CALENDAR: "calendar",
  ANNOTATIONS: "notes",
  ANNOTATIONS_ADD: "notes-add",
  ANNOTATIONS_EDIT: "notes-edit",
  CALENDAR_ANNOTATIONS_ADD: "calendar-notes-add",
  DASHBOARD: "dashboard",
  SETTINGS: "settings",
  EVENT_ADD: "event-add",
  EVENT_EDIT: "event-edit",
  EVENT_VIEW: "event-view",
  TODOS: "goals",
  TODOS_EDIT: 'goals-edit',
  TERMS: "terms",
  PRIVACY: "privacy",
  EVENT_PUBLIC_VIEW: 'event-public-view',
}

const commonMiddleware = [Authentication, ForceTypes]

RouteDesigner.group('',function() {

  // unauthorized
  RouteDesigner.group('',function() {
    RouteDesigner.route("/", "LoginPage", ROUTES.LOGIN)
    RouteDesigner.route("/otp-signin", "OtpPage", ROUTES.OTP)
  }).middleware(commonMiddleware.concat([NotAuthorized]))

  RouteDesigner.route("/terms", "TermsPage", ROUTES.TERMS)
  RouteDesigner.route("/privacy", "PrivacyPage", ROUTES.PRIVACY)

  RouteDesigner.route('/event/view/:publicId', 'EventViewPage', ROUTES.EVENT_PUBLIC_VIEW).meta({ title: 'Calendar', public: true }).middleware(commonMiddleware)

  // authorized
  RouteDesigner.group('', function() {
    RouteDesigner.route("/dashboard", "DashboardPage", ROUTES.DASHBOARD)
    RouteDesigner.route("/complete-profile", "CompleteProfilePage", ROUTES.COMPLETE_PROFILE)
    RouteDesigner.route("/profile-complete", "ProfileCompletePage", ROUTES.PROFILE_COMPLETE)
    RouteDesigner.route("/account-select", "AccountSelectPage", ROUTES.ACCOUNT_SELECT)
  }).middleware(commonMiddleware.concat([Authorized]))

  // authorized and *not subscribed* and owner only
  RouteDesigner.group('', function() {
    RouteDesigner.route("/payment/:plan", "PaymentPage", ROUTES.PAYMENT)
    RouteDesigner.route("/subscription", "SubscriptionPage", ROUTES.SUBSCRIPTION)
  }).middleware(commonMiddleware.concat([Authorized, NotSubscribed, AccountOwner]))

  // authorized and not account owner
  RouteDesigner.group('', function() {
    RouteDesigner.route("/contact-admin", "ContactAdminPage", ROUTES.CONTACT_ADMIN)
  }).middleware(commonMiddleware.concat([Authorized, NotAccountOwner]))

  // authorized, subscribed, and profile complete
  RouteDesigner.group('', function() {
    RouteDesigner.route("/calendar", "CalendarPage", ROUTES.CALENDAR)
    RouteDesigner.route("/settings", "SettingsPage", ROUTES.SETTINGS).meta({ navLayout: 'settings', title: false })
    RouteDesigner.route('/event/add', 'EventAddEditPage', ROUTES.EVENT_ADD).meta({ title: false })
    RouteDesigner.route('/event/:id/:calendarId/edit', 'EventAddEditPage', ROUTES.EVENT_EDIT).meta({ title: false })
    RouteDesigner.route('/event/:id/:calendarId', 'EventViewPage', ROUTES.EVENT_VIEW).meta({ title: false })
    RouteDesigner.route('/todos', 'TodosPage', ROUTES.TODOS).meta({ title: false })
    RouteDesigner.route('/todos/:todoListId', 'TodosAddEditPage', ROUTES.TODOS_EDIT).meta({ title: false })
    RouteDesigner.route('/annotations', 'AnnotationsPage', ROUTES.ANNOTATIONS).meta({ title: false })
    RouteDesigner.route('/annotation', 'AnnotationAddEditPage', ROUTES.ANNOTATIONS_ADD).layout('Empty')
    RouteDesigner.route('/calendar/annotation', 'AnnotationAddEditPage', ROUTES.CALENDAR_ANNOTATIONS_ADD).layout('Empty')
    RouteDesigner.route('/annotation/:id', 'AnnotationAddEditPage', ROUTES.ANNOTATIONS_EDIT).layout('Empty').whereNumber('id')
  }).middleware(commonMiddleware.concat([Authorized, ProfileComplete, Subscribed])).layout('Default')

}).props()
